import { Outlet, useLocation } from "react-router-dom";
import { CatalogToolbar } from "../catalog/CatalogToolbar";
import { CollectionToolbar } from "../collection/CollectionToolbar";
import { useAuth } from "../auth/AuthContext";
import { useNetworkStatus } from "../offline/NetworkStatusContext";
import { ServiceWorkerUpdateBanner } from "../offline/ServiceWorkerUpdateBanner";
import { useCompactShell } from "./useCompactShell";
import { AccountIndicator } from "../components/AccountIndicator";
import { BottomNav } from "./BottomNav";
import { NavItem } from "../components/NavItem";

export function AppShell() {
  const auth = useAuth();
  const { online } = useNetworkStatus();
  const location = useLocation();
  const compactShell = useCompactShell();
  const catalogActive = location.pathname === "/catalog";
  const collectionActive = location.pathname === "/collection";

  return (
    <div className="hw-shell">
      <div className="hw-shell__chrome">
        <ServiceWorkerUpdateBanner />
        <header className="hw-shell__header">
          <div className="hw-shell__brand">
            <p className="hw-shell__product">Hot Wheels</p>
          </div>
          <div className="hw-shell__header-actions">
            {!online ? (
              <span className="hw-network-pill" role="status" aria-live="polite">
                Офлайн
              </span>
            ) : null}
            {auth.status === "authenticated" ? (
              <div className="hw-shell__account">
                <AccountIndicator
                  displayName={auth.account.displayName}
                  isDemo={auth.account.isDemo}
                  demoExpiresAt={auth.account.demoExpiresAt}
                />
              </div>
            ) : null}
          </div>
          {!compactShell ? (
            <nav className="hw-nav hw-nav--desktop" aria-label="Основная навигация">
              <NavItem to="/catalog" label="Каталог" />
              <NavItem to="/collection" label="Коллекция" />
              <NavItem to="/profile" label="Профиль" />
            </nav>
          ) : null}
        </header>
        {catalogActive ? <CatalogToolbar /> : null}
        {collectionActive && !compactShell ? <CollectionToolbar /> : null}
      </div>

      <main className="hw-shell__content">
        <Outlet />
      </main>

      <BottomNav />
    </div>
  );
}
